import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created with ♥ by <b><a href="https://mayallo.com/" target="_blank">Mayallo</a></b>
      {{ year }}
    </span>
  `
})
export class FooterComponent {
  year = new Date().getFullYear();
}
